import store from '@/store'
import { getShortUrl } from '@/api/promote'
const plugin = {
  install: (Vue, options) => {
    // 1. 添加全局方法或属性
    // Vue.myGlobalMethod = function () {
    //   // 逻辑...
    // }

    // 2. 添加全局资源
    // Vue.directive('my-directive', {
    //   bind (el, binding, vnode, oldVnode) {
    //     // 逻辑...
    //   }
    //   ...
    // })

    // 3. 注入组件
    // Vue.mixin({
    //   created: function () {
    //     // 逻辑...
    //   }
    //   ...
    // })
    // 4. add an instance method

    Vue.prototype.$mpNavigateTo = function ({url, success, fail}) {
      const symbol = url.includes('?') ? '&' : '?';
      // let path = `${url}${symbol}fromInner=1`;
      let path = url
      this.$wechat.miniProgram.navigateTo({
        url: path,
        success: (res) => {
          console.log('打开小程序页面成功:', res, path)
          if (success) {
            success(res)
          }
        },
        fail: (res) => {
          console.log('打开小程序页面失败:', res, path)
          if (fail) {
            fail(res)
          }
        }
      })
    }
    Vue.prototype.$mpPostMessage = function ({type, data}) {
      if (!store.getters.is_miniprogram) {
        return;
      }
      console.log('webview发送消息:', type, data)
      let location = window.location.href
      let postData = {type, data, location}
      this.$wechat.miniProgram.postMessage({data: postData})
    }
    Vue.prototype.$shareWechatMsg = function ({shareMP = false, success, cancel}) {
      console.log('1.打开微信小程序页面', store.getters.is_miniprogram, this.$sharePageInfo)
      if (store.getters.is_miniprogram && this.$sharePageInfo && this.$sharePageInfo.link) {

        const urlCallback = (url) => {
          let info = this.$sharePageInfo
          info.link = url
          if (info.title && info.title.length > 30) {
            info.title = info.title.substring(0, 30) + '…'
          }
          if (info.desc && info.desc.length > 30) {
            info.desc = info.desc.substring(0, 30) + '…'
          }
          // if (shareMP) {
            // 开放所有分享页面
            info.shareMP = 1
          // }
          info = JSON.stringify(info)
          info = encodeURIComponent(info)
          let path = `/pages/shareCopyLink/index?info=${info}`    
          console.log('2.开始打开微信小程序页面', path)
          this.$mpNavigateTo({
            url: path,
            success: success,
            fail: cancel
          })
        }
        // 去掉短链，会让小程序无法传参
        let link = this.$sharePageInfo.link
        // getShortUrl(link).then(res => {
        //   if (res.code == 1) {
        //     link = res.data.url
        //   }
        //   urlCallback(link)
        // }).catch((e) => {
          // console.log('获取短链失败',e)
          urlCallback(link)
        // })

      } else {
        console.log('2.结果：不打开微信小程序',store.getters.miniProgram)
        cancel()
      }
    }
    Vue.prototype.$openFileWechatInMP = function ({title, desc, link, image_url, success, cancel}) {
      console.log('1.打开微信小程序页面', store.getters.is_miniprogram, this.$sharePageInfo)
      if (store.getters.is_miniprogram && link) {
        let info = {
          title,
          desc,
          link,
          image_url
        }
        info = JSON.stringify(info)
        info = encodeURIComponent(info)
        let path = `/pages/openFile/index?info=${info}`    
        console.log('2.开始打开微信小程序文件页面', path)
        this.$mpNavigateTo({
          url: path,
          success: success,
          fail: cancel
        })
      } else {
        console.log('2.结果：不打开文件微信小程序',store.getters.is_miniprogram)
        if (cancel) {
          cancel()
        }
      }
    }
    Vue.prototype.$setPageCard = function ({title, desc, link, image_url, success, cancel, trigger}) {
      const setShare = () => {
        image_url = image_url || 'https://img.aakit.cn/classkit/static/images/social/notification.png'
        let envs = ['env=AACloud', 'env=AAAttachment', 'env=AAParent']
        envs.forEach(element => {
          if (link.indexOf(element) > 0) {
            link = link.replace(element, 'env=share')
          }
        });
        let data = {title, desc, link, image_url}
        Vue.prototype.$sharePageInfo = data
        this.$mpPostMessage({
          type: 'share',
          data: data
        })
        console.log('设置分享链接:', data)
        this.$wechat.onMenuShareAppMessage({ // 分享给朋友
          title: title,
          desc: desc,
          link: link,
          imgUrl: image_url,
          type: '',
          dataUrl: '',
          trigger: function (res) {
            if (typeof trigger == 'function') {
              trigger('friend')
            }
          },
          success: function () {
            if (typeof success == 'function') {
              success('friend')
            }
          },
          cancel: function () {
            if (typeof cancel == 'function') {
              cancel('friend')
            }
          },
          fail: function(e) {
            console.log('onMenuShareAppMessage:share failed')
          }
        })
        this.$wechat.onMenuShareTimeline({ // 分享朋友圈
          title: title,
          link: link,
          imgUrl: image_url,
          trigger: function (res) {
            if (typeof trigger == 'function') {
              trigger('timeline')
            }
          },
          success: function () {
            if (typeof success == 'function') {
              success('timeline')
            }
          },
          cancel: function () {
            if (typeof cancel == 'function') {
              cancel('timeline')
            }
          },
          fail: function(e) {
            console.log('onMenuShareTimeline:share failed')
          }
        })
        this.$wechat.onMenuShareQQ({ // 分享朋友圈
          title: title,
          desc: desc,
          link: link,
          imgUrl: image_url,
          trigger: function (res) {
            if (typeof trigger == 'function') {
              trigger('qq')
            }
          },
          success: function () {
            if (typeof success == 'function') {
              success('qq')
            }
          },
          cancel: function () {
            if (typeof cancel == 'function') {
              cancel('qq')
            }
          },
          fail: function(e) {
            console.log('onMenuShareQQ:share failed')
          }
        })
      }

      // setShare()
      this.$wechat.ready(setShare)
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/ShareUtil.js